export const DYNAMIC_CONTENT_PAGE_SEO_TO_FOLDER_MAPPING:Record<string,string> = {
    "gaming-blog":"Gaming-blog",
    "over-ons":"Over ons",
    "blog":"blog",
    "klantenservice":"Klantenservice"
}

export const DYNAMIC_CONTENT_PAGE_FOLDER_TO_SEO_MAPPING:Record<string,string> = {
    "gaming-blog":"gaming-blog",
    "over ons":"over-ons",
    "blog":"blog",
    "klantenservice":"klantenservice"
}

export const DYNAMIC_CONTENT_PARENT_PAGE_SEO_URL:Record<string,string> = {
    // Please keep these entries always in lowercase.
    "gaming-blog":"gaming-blog-overzicht",
    "over ons":"over-ons-overzicht",
    "blog":"blog-overzicht",
    "klantenservice":"klantenservice-overzicht",
    "mijn account":"mijn-account"
}

export const ALLOWED_CANONICAL_STATIC_ROUTES = ['winkel-zoeken'];

export const MY_ACCOUNT_X_CUSTOM_FIELD_2 = "MIJN ACCOUNT";

export const MY_ACCOUNT_MENU_PAGENAME_TO_LABELS_MAPPING:Record<string,string> = {
    "OrderDetailsPage":"Bestellingen",
    "AccountPage":"Mijn account",
    "MyOrders":"Bestellingen",
    "PersonalInfoPage":"Gegevens en voorkeuren",
    "MyAddressBookPage":"Adresboek",
    "ReturnOrderPage":"Retourneren",
    "WishListsPage":"Verlanglijstjes",
    "SharedWishListView":"Gedeelde verlanglijstje"
}